import * as React from 'react';
import { useState } from 'react';
import Col from 'reactstrap/lib/Col';
import Modal from 'reactstrap/lib/Modal';
import ModalBody from 'reactstrap/lib/ModalBody';
import Row from 'reactstrap/lib/Row';
import { cancelTour, MyToursPageTourDto } from '../../../../../api/MyTours';
import { TourStatuses } from '../../../../../utilities/Enums';
import FormValidationDisplay from '../../../../common/form/ValidationDisplay';
import { LoadingDisplay } from '../../../../common/LoadingOverlay';

interface Props {
    isOpen: boolean;
    close: () => void;
    tour: MyToursPageTourDto;
    guestCardGuid: string;
    setTourStatus: (status: TourStatuses) => void;
}

const TourCancelPopup = (props: Props) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);

    const handleCancel = async () => {
        setLoading(true);
        let result = await cancelTour(props.tour.tourGuid);

        if (result.success) {
            setLoading(false);
            props.close();
            props.setTourStatus(TourStatuses.Cancelled);
        } else {
            setLoading(false);
            setErrorMessage(result.error);
        }
    };

    return (
        <Modal isOpen={props.isOpen} centered={true}>
            <ModalBody className="reschedule-modal">
                <FormValidationDisplay errorMessage={errorMessage} />
                {loading ? (
                    <LoadingDisplay />
                ) : (
                    <>
                        <p style={{ fontWeight: 600 }}>
                            Are you sure that you want to cancel your tour?
                        </p>
                        <Row>
                            <Col className="reschedule-popup-buttons">
                                <button
                                    className="reschedule-popup-cancel"
                                    onClick={() => props.close()}
                                >
                                    No
                                </button>
                                <button
                                    className="reschedule-popup-reschedule"
                                    onClick={() => handleCancel()}
                                >
                                    Yes
                                </button>
                            </Col>
                        </Row>
                    </>
                )}
            </ModalBody>
        </Modal>
    );
};

export default TourCancelPopup;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/tour/allTours/TourCancelPopup.tsx